import { Directive, ElementRef, Inject, Input, OnDestroy, OnInit, Optional, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../../@core/services/Auth.service';
import { CF_COMPONENT, IConditionalFormattingComponent } from '../../rule-engine/directives/condition-formatting.directive';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[zappPermissionsOnly]',
  standalone: true
})
export class PermissionsOnlyDirective {

  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _permissionsService: PermissionService) { }

  @Input() set zappPermissionsOnly(permissions: string[]) {
    if (this._permissionsService.hasPermission(permissions)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}

@Directive({
  selector: '[zapphaspermission]',
  standalone: true
})
export class HasPermissionDirective implements OnDestroy {
  private hasView = false;
  private _component: IConditionalFormattingComponent;
  private _destroyed = false;
  private _requestId = 0;

  constructor(
    private elementRef: ElementRef<any>,
    private _permissionsService: PermissionService,
    private authService: AuthService,
    @Optional() @Inject(CF_COMPONENT) component: IConditionalFormattingComponent | null) {
    if (component?._elementRef != null && component?._elementRef?.nativeElement === elementRef.nativeElement) {
      this._component = component;
    }
  }

  @Input() set zapphaspermission(data: ActionAuthorization) {
    if (data == null) {
      return;
    }

    const requestId = ++this._requestId;
    this.applyAuthorization(data, requestId);
  }

  private async applyAuthorization(data: ActionAuthorization, requestId: number): Promise<void> {
    let operationAllowed: boolean | null = await this.authService.hasAccess({
      operation: data.operation,
      allowAnonymous: data.allowAnonymous,
      allowAuthenticated: data.allowAuthenticated,
      permissions: data.permissions
    });

    if (this._destroyed || requestId !== this._requestId) {
      return;
    }

    if (operationAllowed) {
      if (this._component?.noPermission == true) {
        this._component.noPermission = false;
        this.elementRef.nativeElement.style.display = 'block';
        this.elementRef.nativeElement.disabled = undefined;
      }
      return;
    }

    this._component.noPermission = true;

    if (data.action === 'HIDE') {
      this.elementRef.nativeElement.style.display = 'none';
      return;
    }

    this.elementRef.nativeElement.disabled = 'disabled';
  }

  ngOnDestroy(): void {
    this._destroyed = true;
  }
}

export interface ActionAuthorization {
  operation?: string,
  allowAnonymous?: boolean,
  allowAuthenticated?: boolean,
  permissions?: string[];
  action: 'HIDE' | 'DISABLE';
}
